module.exports = __webpack_public_path__ + "static/media/editor.1dc86301.svg";